import React from 'react';
import PropTypes from "prop-types";

import BookingService from "../../../services/bookings";
import {DateFormatter} from "../../../services/date";

import {DatePicker} from "@mui/x-date-pickers";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField/TextField";
import Typography from "@mui/material/Typography";


const BookingItem = props => {
    const {index, formik} = props;
    const bookingItem = formik.values.bookingItems[index];

    const {arrival, departure} = formik.values;

    const touchedItem = formik.touched.bookingItems && formik.touched.bookingItems[index];
    const errorItem = formik.errors.bookingItems && formik.errors.bookingItems[index];

    return (
        <Paper variant="outlined" sx={{p: 2, my: 1}}>
            <Grid container item spacing={1} alignItems="center">
                <Grid item xs={12} md={6}>
                    <Typography variant="body2" fontWeight="normal">
                        {bookingItem.accommodation.name} - {bookingItem.name}
                    </Typography>
                    <Typography variant="caption" fontWeight="light">
                        {DateFormatter.shortString(arrival)} - {DateFormatter.shortString(departure)}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField type="number"
                               variant="standard"
                               label="Importo (campo non obbligatorio)"
                               fullWidth
                               name={`bookingItems[${index}].price`}
                               value={formik.values.bookingItems[index].price ?? ''}
                               onChange={formik.handleChange}
                               error={touchedItem?.price && Boolean(errorItem?.price)}
                               helperText={touchedItem?.price && errorItem?.price}
                               InputProps={{
                                   startAdornment: <InputAdornment position="start">€</InputAdornment>,
                               }}/>
                </Grid>
            </Grid>
        </Paper>
    )
}

const StepAmount = props => {
    const {booking, formik, accommodations} = props;

    const totalPrice = formik.values.bookingItems.reduce(
        (acc, x) => {
            const price = Number.parseFloat(x.price) || 0;
            return acc + price;
        }, 0);

    const showTotal = formik.values.bookingItems.length > 1 && totalPrice > 0;

    return (
        <>
            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
                Importo concordato
            </Typography>

            {
                formik.values.bookingItems.map((_, i) => (
                    <BookingItem key={i} index={i} formik={formik} accommodations={accommodations}/>
                ))
            }

            {
                showTotal &&
                <Typography fontWeight="medium" textAlign="right" sx={{mt: 2}}>
                    {`Totale ${totalPrice} €`}
                </Typography>
            }

            <Typography variant='h6' color='primary' fontWeight="normal" sx={{
                mt: showTotal ? 2 : 3,
                mb: 2
            }}>
                Caparra
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <TextField type="number"
                               label="Importo caparra (campo non obbligatorio)"
                               fullWidth
                               name="deposit"
                               value={formik.values.deposit ?? ''}
                               onChange={formik.handleChange}
                               error={formik.touched.deposit && Boolean(formik.errors.deposit)}
                               helperText={formik.touched.deposit && formik.errors.deposit}
                               InputProps={{
                                   startAdornment: <InputAdornment position="start">€</InputAdornment>,
                               }}/>
                </Grid>

                {
                    !booking.id &&
                    <>

                        <Grid item container alignItems="center" xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="depositPayed"
                                        color="primary"
                                        checked={formik.values.depositPayed}
                                        onChange={formik.handleChange}/>
                                }
                                label={formik.values.depositPayed ? "Caparra pagata" : "Caparra non ancora pagata"}/>
                        </Grid>

                        {
                            formik.values.depositPayed &&
                            <>
                                <Grid item xs={12} md={6}>
                                    <DatePicker
                                        value={formik.values.depositPayedAt}
                                        onChange={date => formik.setFieldValue("depositPayedAt", date)}
                                        disableFuture
                                        label="Data pagamento caparra"
                                        closeOnSelect
                                        disableHighlightToday={true}
                                        showDaysOutsideCurrentMonth={true}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                error: Boolean(formik.touched.depositPayedAt) && Boolean(formik.errors.depositPayedAt),
                                                helperText: formik.touched.depositPayedAt && formik.errors.depositPayedAt
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField select
                                               fullWidth
                                               name="depositPaymentType"
                                               label="Modalità pagamento caparra"
                                               value={formik.values.depositPaymentType}
                                               onChange={formik.handleChange}>
                                        {
                                            BookingService.enums.PAYMENTS_TYPES.map(t => (
                                                <MenuItem key={t.value} value={t.value}>
                                                    {t.label}
                                                </MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </Grid>
                            </>
                        }
                    </>
                }
            </Grid>
        </>
    );
};

StepAmount.propTypes = {
    formik: PropTypes.object.isRequired,
    accommodations: PropTypes.object.isRequired,
};

export default StepAmount;